import {APP_CONFIG} from "../helpers/appHelpers";
import {PaginatorInfo} from "./generic.dto";
import {CurrencyDto} from "./currency.dto";

export type Country = {
    id: number;
    code: string;
    name: string;
    flagUrl: string;
    active: boolean;
    currencyId: number;
    maxLoanDeductionPercentage: number | null;
    applyLoanDeductionOnBasic: boolean | null;
    centralBankInterestRate: number | null;
    taxNumberRequired: boolean;
    minimumEmploymentAge: number | null;
    createdAt: Date;
    modifiedAt: Date | null;
}

export type CountryInterestRateHistory = {
    id: number;
    countryId: number;
    previousValue: number | null;
    currentValue: number | null;
    actor: any;
    timestamp: Date;
}

export class CreateCountryDto {
    code!: string;
    name!: string;
    flagUrl!: string;
    active?: boolean;
    currencyId!: number;
    maxLoanDeductionPercentage?: number;
    applyLoanDeductionOnBasic?: boolean;
    centralBankInterestRate?: number;
    taxNumberRequired?: boolean;
    minimumEmploymentAge?: number;
}

export class UpdateCountryDto {
    name?: string;
    active?: boolean;
    flagUrl?: string;
    currencyId?: number;
    maxLoanDeductionPercentage?: number;
    applyLoanDeductionOnBasic?: boolean;
    centralBankInterestRate?: number;
    taxNumberRequired?: boolean;
    minimumEmploymentAge?: number;
}

export interface CountryDto extends Country { }
export interface CountryInterestRateHistoryDto extends CountryInterestRateHistory { }

export enum CountryOrderBy {
    CREATED_AT_ASC = 'createdAt:asc',
    CREATED_AT_DESC = 'createdAt:desc',
    NAME_ASC = 'name:asc',
    NAME_DESC = 'name:desc',
    CODE_ASC = 'code:asc',
    CODE_DESC = 'code:desc',
    MODIFIED_AT_ASC  = 'modifiedAt:asc',
    MODIFIED_AT_DESC  = 'modifiedAt:desc'
}

export class QueryCountryDto {
    code?: string;
    active?: boolean;
    currencyId?: number;
    page?: number = 1;
    limit?: number = APP_CONFIG.PAGE_LIMIT;
    orderBy?: CountryOrderBy = CountryOrderBy.CREATED_AT_DESC;
}

export type DetailedCountryDto = Country & {
    currency?: Currency | null;
}

type Currency = {
    id: number;
    code: string;
};

export interface CountryPaginator extends PaginatorInfo<CountryDto> {}
export interface CountryInterestRateHistoryPaginator extends PaginatorInfo<CountryInterestRateHistoryDto> {}

export class SearchCountryDto {
    q?: string;
  
    page= 1;
    limit?: number;
    orderBy: CountryOrderBy = CountryOrderBy.CREATED_AT_DESC;
  }

export class QueryCountryInterestRateHistoryDto {
  countryId?: number;
  'timestamp.gte'?: string;
  'timestamp.lte'?: string;

  page = 1;
  limit?: number;
  orderBy: CountryInterestRateHistoryOrderBy = CountryInterestRateHistoryOrderBy.TIMESTAMP_DESC;
}

export enum CountryInterestRateHistoryOrderBy {
  TIMESTAMP_ASC = 'timestamp:asc',
  TIMESTAMP_DESC = 'timestamp:desc',
}